/** The rail body's tab switch (unit convention §1). */
import React from 'react';

import {useTabBodyModel} from './model';
import TabBodyView from './View';

export default React.memo(function TabBody() {
  return <TabBodyView {...useTabBodyModel()} />;
});
